import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow-right-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a476163"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "External Link"
}, null, -1))

import { onMounted, ref } from 'vue';

type ImageProps = {
  metadataUrl: string | null | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOriginalMedia',
  props: {
    metadataUrl: {}
  },
  setup(__props: any) {

const props = __props;

const metadataUrl = ref('');

onMounted(async () => {
  // get on-chain data on load
  try {
    metadataUrl.value = await getMetadataUrl();
  } catch (e) {
    console.warn('Metadata url lookup error', e);
  }
});



const getMetadataUrl = async (): Promise<string> => {
  if (props.metadataUrl) {
    const metadataURL = await parseTokenMetadata(props.metadataUrl);
    return metadataURL;
  }
  return '';
};

const parseTokenMetadata = async (url: string): Promise<string> => {
  const response = await fetch(url);

  const metadata = await response.json();
  return metadata.animation_url || metadata.animation || metadata.image_url || metadata.image;
};

return (_ctx: any,_cache: any) => {
  return (metadataUrl.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "campaign-view-original-media",
        target: "_blank",
        href: metadataUrl.value
      }, [
        _createTextVNode(" View Original Media "),
        _hoisted_2
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})